import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "floatingwindowsize"
    }}>{`FloatingWindowSize`}</h1>
    <p>{`The size of the movie's floating window. Valid only when floating window is true.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_FIFTH`}</strong>{` = 1298557286`}</p>
      <p parentName="blockquote">{`The floating window is one fifth the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_FOURTH`}</strong>{` = 1298558834`}</p>
      <p parentName="blockquote">{`The floating window is one fourth the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_HALF`}</strong>{` = 1298686316`}</p>
      <p parentName="blockquote">{`The floating window is one half the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL`}</strong>{` = 1298560364`}</p>
      <p parentName="blockquote">{`The floating window is the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWICE`}</strong>{` = 1299476344`}</p>
      <p parentName="blockquote">{`The floating window is twice the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRIPLE`}</strong>{` = 1299477112`}</p>
      <p parentName="blockquote">{`The floating window is triple the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`QUADRUPLE`}</strong>{` = 1299281272`}</p>
      <p parentName="blockquote">{`The floating window is quadruple the length and height of the movie's original display size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MAX`}</strong>{` = 1299014008`}</p>
      <p parentName="blockquote">{`The floating window fills the entire screen.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      